import MilestonesSerializer from './base';

export default class Set extends MilestonesSerializer {}
